import CardFormats from '~/components/Molecules/CardFormats/CardFormats.vue'

export default {
  props: {
    tag: {
      type: String,
    },

    title: {
      type: Object,
    },

    body: {
      type: String,
    },

    carousel: {
      type: Array,
    },

    carouselColumns: {
      type: String,
      default: '4',
    },

    theme: {
      type: String,
      default: '',
      validator: prop => ['', 'light'].includes(prop),
    },
  },

  components: {
    hotCarousel: () => import('~/components/Molecules/Carousel/Carousel.vue'),
  },

  data() {
    return {
      cardFormats: CardFormats,
      swiperOptions: {
        slidesPerView: 1.1,
        spaceBetween: 16,
        allowTouchMove: true,
        breakpoints: {
          480: {
            slidesPerView: 2.1,
          },
          768: {
            slidesPerView: 2.2,
            spaceBetween: 32,
          },
          800: {
            slidesPerView: 3.2,
            spaceBetween: 32,
          },
          1024: {
            slidesPerView: this.carouselColumns,
            allowTouchMove: false,
            spaceBetween: 32,
          },
        },
      },
    }
  },
}
